// extracted by css-extract-rspack-plugin
export default {"cards":"WfNRGMqkkWYx8cPa"};